import { AlertTriangle } from 'lucide-react';
import React from 'react';
import { typography } from '../../styles/typography';

const DeletePatrolWarning = ({ onCancel, onConfirm, isVisible = false }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="w-[520px] px-8 py-6 bg-neutral-50/50 rounded-xl shadow-[0px_15px_30px_0px_rgba(0,0,0,0.10)] shadow-[0px_5px_20px_0px_rgba(255,255,255,0.10)] shadow-[inset_0px_4px_25px_0px_rgba(255,255,255,0.35)] outline outline-1 outline-offset-[-1px] outline-neutral-300/20 backdrop-blur-[30px] inline-flex flex-col justify-start items-start gap-6 overflow-hidden">
        {/* Header Section */}
        <div className="self-stretch inline-flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
            <div className={`${typography.h2} text-black`}>
              Delete Patrol
            </div>
          </div>
          <button 
            onClick={onCancel}
            className="w-12 h-12 relative bg-stone-950/10 rounded overflow-hidden hover:bg-stone-950/20 transition-colors duration-200 cursor-pointer"
          >
            <div className="w-6 h-6 left-[12px] top-[12px] absolute overflow-hidden flex items-center justify-center">
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className="text-zinc-950"
              >
                <path 
                  d="M18 6L6 18M6 6L18 18" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </button>
        </div>

        {/* Content Section */}
        <div className="self-stretch flex flex-col justify-start items-start gap-4">
          {/* Warning Message */}
          <div className="w-full">
            <p className={`${typography.body1} text-gray-800 mb-3`}>
              Are you sure you want to delete this patrol?
            </p>
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className={`${typography.body2} text-red-800`}>
                <strong>Warning:</strong> This action will permanently delete:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm text-red-700">
                <li>The patrol schedule</li>
                <li>All attendance records</li>
                <li>All QR check-ins</li>
                <li>All location tracking data</li>
              </ul>
              <p className={`${typography.body2} text-red-800 mt-3 font-semibold`}>
                This action cannot be undone.
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="self-stretch inline-flex justify-start items-start gap-4">
            {/* Cancel Button */}
            <button
              onClick={onCancel}
              className="flex-1 h-12 px-6 py-3 bg-gray-200 rounded-lg inline-flex flex-col justify-center items-center gap-2.5 hover:bg-gray-300 transition-colors duration-200"
            >
              <div className={`${typography.h5} text-center justify-center text-gray-800`}>
                Cancel
              </div>
            </button>

            {/* Confirm Delete Button */}
            <button
              onClick={onConfirm}
              className="flex-1 h-12 px-6 py-3 bg-red-600 rounded-lg inline-flex flex-col justify-center items-center gap-2.5 hover:bg-red-700 transition-colors duration-200"
            >
              <div className={`${typography.h5} text-center justify-center text-white`}>
                Yes, Delete
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePatrolWarning;
